import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-2 pt-2 text-left" }
const _hoisted_2 = {
  key: 0,
  class: "text-subtitle-1 font-weight-bold mt-1"
}
const _hoisted_3 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_4 = {
  key: 1,
  class: "text-body-2 text-medium-emphasis"
}

import { computed } from "vue";
import { juegaEn, PartidaConJugadores } from "@/composables/useRondasEnPestana";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectorRondas',
  props: {
    modelValue: {},
    rondas: {},
    partidasPorRonda: {},
    jugador: {},
    jugadores: {}
  },
  emits: ["update:modelValue", "update:jugador"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const generada = (n: number) => (props.partidasPorRonda[n]?.length ?? 0) > 0;

const nickBuscado = computed(
  () => props.jugadores.find(j => j.idUsuario === props.jugador)?.nick
);
const juegaEnRonda = computed(
  () =>
    props.jugador !== null &&
    !!props.modelValue &&
    (props.partidasPorRonda[props.modelValue] ?? []).some(p =>
      juegaEn(p, props.jugador as number)
    )
);

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_chip_group, {
      "model-value": _ctx.modelValue,
      column: "",
      mandatory: "",
      "selected-class": "text-primary",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rondas, (n) => {
          return (_openBlock(), _createBlock(_component_v_chip, {
            key: n,
            value: n,
            size: "small",
            filter: "",
            variant: generada(n) ? 'tonal' : 'outlined'
          }, {
            default: _withCtx(() => [
              _createTextVNode(" R" + _toDisplayString(n), 1)
            ]),
            _: 2
          }, 1032, ["value", "variant"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_v_autocomplete, {
      "model-value": _ctx.jugador,
      items: _ctx.jugadores,
      "item-title": "nick",
      "item-value": "idUsuario",
      label: "Partidas de un jugador",
      "prepend-inner-icon": "mdi-magnify",
      density: "compact",
      clearable: "",
      "hide-details": "",
      class: "mt-1 mb-2",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:jugador', $event ?? null)))
    }, null, 8, ["model-value", "items"]),
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [
          _createTextVNode(" Ronda " + _toDisplayString(_ctx.modelValue) + " ", 1),
          (!generada(_ctx.modelValue))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " · aún sin generar "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.modelValue && _ctx.jugador !== null && generada(_ctx.modelValue) && !juegaEnRonda.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(nickBuscado.value) + " no juega en esta ronda. ", 1))
      : _createCommentVNode("", true)
  ]))
}
}

})